import React, { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { cleanFieldProps, parseClasses } from '../../lib/ep.js';

import FieldWrapper from './FieldWrapper.js';

const Pin = (props) => {
	const name = props?.name ?? false;
	if(name === false) return null;

	const pin_length = props?.pin_length ?? 4;

	const pin_array = (size) => {
		let _array = [];
		for(let index = 0; index < size; index++) _array.push('');
		return _array;
	}

	const [ pin, setPin ] = useState(pin_array(pin_length));
	const [ inputIndex, setInputIndex ] = useState(0);

	const inputs = useRef([]);

	const resetPin = () => {
		let _pin = [...pin];
			_pin.forEach((element, index) => {
				_pin[index] = '';
			});
			setPin(_pin);
			inputs.current[0].focus();
	}

	useEffect(() => {
		if(props.value == '')resetPin();
	}, [props]);

	useEffect(() => {
		inputs.current[inputIndex].focus();
	}, [ inputIndex ]);

	const disabled = props?.disabled ?? false;

	const handlePinChange = (value, index) => {
		//const { value, maxLength } = e.target;
		const maxLength = 1;
		let sanitizedValue = value.replace(/[^0-9]/g, ''); // Elimina caracteres no numéricos
		//sanitizedValue = sanitizedValue.replace(/^0+/, ''); // Elimina ceros iniciales
		
		const pinValue = sanitizedValue.slice(0, maxLength);
		const updatedPin = [ ...pin ];
		updatedPin[index] = parseInt(pinValue, 10).toString();
		if(props.onChange != undefined) props.onChange(updatedPin.join(""));
		setPin(updatedPin);
		if(sanitizedValue !==''){
			// Saltar al siguiente input cuando se suelta el botón del mouse
			if(value.length === 1 && index < inputs.current.length - 1) {
				inputs.current[index+1].focus();
			}
		}
	};

	const handleKeyDown = (e,index) => {
		//const { value, maxLength } = e.target;
		handlePinChange(e.key,index);
	}

	const wrapper_props = cleanFieldProps(props);

	let classname = props?.classname ?? 'input text in_top';
	classname = parseClasses(classname, props._class, 'input');

	let field_class = ['common_form_item'];
	if(disabled) field_class.push('disabledField disabledItem');

	return (
		<FieldWrapper type='pin' {...wrapper_props} display_error_at_bottom={true}>
			{pin.map((digit, index) => {
				return (
					<input
						key={index}
						ref={(el) => (inputs.current[index] = el)}
						name='input'
						//inputMode="numeric"
						type="number"
						dir='auto'
						value={digit}
						class={`${classname} ${field_class.join(" ")}`}
						min={0}
						max={9}
						maxLength={1}
						/*onChange={(e) => handlePinChange(e, index)}*/
						onKeyDown={(e) => handleKeyDown(e, index)}
						//pattern="[0-9]+"
					/>
				)
			})}
		</FieldWrapper>
	);
}

export default injectIntl(Pin);